import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

//Components
import Nav from './nav';
import NavLang from './nav-lang';

gsap.registerPlugin(ScrollToPlugin);

const Footer = ({ lang }) => {
  const footerRef = useRef(null);
  const footerInnerRef = useRef(null);

  const scrollToTop = () =>
    gsap.to(window, { duration: 1, scrollTo: 0, ease: 'power2' });

  //Translate footer effect
  useEffect(() => {
    if (window.innerWidth > 767) {
      gsap.set(footerRef.current, {
        yPercent: 40,
        force3D: true,
      });
      gsap.set(footerInnerRef.current, {
        yPercent: -100,
        opacity: 0,
        force3D: true,
      });

      const footerParallaxEffect = e => {
        const footerHeight = footerRef.current.clientHeight;
        const docHeight = document.body.clientHeight;

        if (window.scrollY + window.innerHeight > docHeight - footerHeight) {
          const visiblePercentage =
            ((docHeight - window.scrollY - window.innerHeight) / footerHeight) *
            100;
          gsap.to(footerRef.current, {
            duration: 0.7,
            yPercent: visiblePercentage * 0.4,
            force3D: true,
            ease: 'power4.out',
          });
          gsap.to(footerInnerRef.current, {
            duration: 0.5,
            yPercent: -visiblePercentage,
            opacity: 1 - (visiblePercentage * 1.3) / 100,
            force3D: true,
            ease: 'circ.out',
          });
        }
      };

      window.addEventListener('scroll', footerParallaxEffect);

      return () => window.removeEventListener('scroll', footerParallaxEffect);
    }
  }, []);

  return (
    <footer ref={footerRef} className="footer pt-7 pt-md-12">
      <div className="footer__back-to-top pb-xl-12">
        <button onClick={scrollToTop} className="text-title font-weight-normal">
          <i className="fa fa-long-arrow-up mb-xl-3" aria-hidden="true"></i>
          <span>Top</span>
        </button>
      </div>

      <div className="footer__inner" ref={footerInnerRef}>
        <div className="container">
          <div className="nav-footer position-relative mb-5">
            <Nav lang={lang} />
          </div>

          <NavLang lang={lang} />

          <div className="footer__bar d-flex align-items-center justify-content-between py-5 pr-6 mt-7">
            <p>© BG Steel Ltd. 2020</p>

            <a
              href="https://stan.vision"
              target="_blank"
              rel="noopener noreferrer"
              className="design-by-stan-vision d-flex align-items-center"
            >
              <span className="sv-logo mr-3"></span>
              <span>
                Design by <em>StanVision</em>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
